import { z } from "zod";

export const yourDetailsSchema = z.object({
  firstName: z.string().min(1, "First Name is required"),
  lastName: z.string().min(1, "Last Name is required"),
  email: z.string().email("Email is required"),
  password: z
    .string()
    .min(12, "Password must be at least 12 characters long")
    .regex(/.*[0-9].*/, "Password must contain at least 1 number")
    .regex(
      /.*[\^$*.[\]{}()?"!@#%&/\\,><':;|_~`=+\- ].*/,
      "Password must contain at least 1 special character",
    )
    .regex(/.*[A-Z].*/, "Password must contain at least 1 uppercase letter")
    .regex(/.*[a-z].*/, "Password must contain at least 1 lowercase letter"),
  isSubscribedToMarketing: z.boolean().optional(),
  hasAcceptedTerms: z.boolean().refine((val) => val === true, {
    message: "You must accept the EULA",
  }),
});

export type YourDetailsFormData = z.infer<typeof yourDetailsSchema>;
